/** Mount for the shared "Jules Tools" menu. The dropdown itself — tool list, per-person
    favourites, data-lineage viewer — is rendered into this element by nav.js, loaded
    from the hub in index.html. The link inside is the fallback: nav.js hides it once it
    has run, so it is only ever visible if the script never loads (cvp down, a 404), and
    the header still has its way out. */
export default function ToolsNav() {
  return (
    <div data-jules-nav>
      <a
        href="https://cvp.julianfife.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
      >
        Jules Tools
      </a>
    </div>
  );
}
